import { render, staticRenderFns } from "./EventBadge.vue?vue&type=template&id=dac19bea&scoped=true&"
import script from "./EventBadge.vue?vue&type=script&lang=js&"
export * from "./EventBadge.vue?vue&type=script&lang=js&"
import style0 from "./EventBadge.vue?vue&type=style&index=0&id=dac19bea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac19bea",
  null
  
)

export default component.exports